import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
  arrUserListing: [],
  isDeleteListing: false,
  isSoldListing: false
};
const getters = {
  // categoriesOptions: (state) => state.categoriesOptions
};

const actions = {
  [actionType.GET_USER_LISTING]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("/user/listings",{
        params:{
          take: params.take,
          page: params.page,
          search: params.search,
          fillter: params.fillter,
          sort_by: params.sort_by
        }
      })
      .then(result => {
        if(result.data.data) {
          let response = {
            page: params.page,
            data: result.data.data
          }
          commit(mutationType.SET_USER_LISTING, response);
          commit(mutationType.IS_DELETE_LISTING, false)
        }
        resolve(result)
      })
        .catch(error =>{ 
          commit(mutationType.IS_DELETE_LISTING, false);
          reject(error)
        });
    });
  },
  [actionType.GET_NOT_SEEN]: async function ({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .get(`/user/listings/not-seen`)
        .then((result) => {
          if (result.data.data) {
            let response = {
              data: result.data.data
            };
            resolve(response);
          }
        })
        .catch((error) => reject(error));
    });
  },
  [actionType.UPDATE_NOT_SEEN]: async function ({ commit }, type) {
    return new Promise((resolve, reject) => {
      api
        .put(`/user/listings/mark-as-seen?filter=${type}`)
        .then((result) => {
          resolve(result.data.data);
        })
        .catch((error) => reject(error));
    });
  },
  [actionType.SOLD_LISTING]: async function ( commit ,params) {
    return new Promise((resolve, reject) => {
      api.put(`/user/listings/close/${params.id}`,{status: params.status,motive :params.motive })
      .then(result => {
        commit(mutationType.IS_SOLD_LISTING)
      })
        .catch(error => reject(error));
    });
  },
  [actionType.DELETE_LISTING]: async function ({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete(`/user/listings/${id}`)
      .then(result => {
        commit(mutationType.IS_DELETE_LISTING, true)
      })
        .catch(error => {
          commit(mutationType.IS_DELETE_LISTING, false);
          reject(error)
        });
    });
  },
  [actionType.RENEW_LISTING]: async function ({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.put(`/user/listings/renew/${id}`)
      .then(result => {
        resolve(result)
      })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [mutationType.SET_USER_LISTING](state, data) {
    if(data.data.length > 0) {
      if(data.page == 1) {
          state.arrUserListing = data.data
      }
      else {
          state.arrUserListing = state.arrUserListing.concat(data.data);
      }
    }
  },
  [mutationType.IS_DELETE_LISTING](state,data) {
    state.isDeleteListing = data
  },
  [mutationType.IS_SOLD_LISTING](state) {
    state.isSoldListing = true
  },
  [mutationType.RESET_USER_LISTING]: function(state) {
    state.arrUserListing = []
}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}